import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  Language,
  getDirection,
  getFontClass,
} from '../thi/thi-translations';
import { normalizeThiLang } from '../thi/thi-lang.util';
import { ThiCampaignAttributionService } from '../thi/campaign/thi-campaign-attribution.service';
import { ThiLandingAnalyticsService } from '../thi/campaign/thi-landing-analytics.service';

@Component({
  selector: 'app-campaign-landing',
  templateUrl: './campaign-landing.component.html',
  styleUrls: ['./campaign-landing.component.scss'],
})
export class CampaignLandingComponent implements OnInit {
  landingLang: Language = 'ar';
  dir: 'rtl' | 'ltr' = 'rtl';
  fontClass = 'font-cairo';
  showStickyCta = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly attribution: ThiCampaignAttributionService,
    private readonly analytics: ThiLandingAnalyticsService,
  ) {}

  ngOnInit(): void {
    const raw = localStorage.getItem('curentLang') || 'ar';
    this.landingLang = normalizeThiLang(raw);
    this.dir = getDirection(this.landingLang);
    this.fontClass = getFontClass(this.landingLang);
    this.translate.use(this.landingLang);

    this.route.queryParams.subscribe((params) => {
      this.attribution.captureFromRoute(params);
    });

    this.analytics.landingPageView(this.landingLang);
  }

  onScrolledPastHero(past: boolean): void {
    this.showStickyCta = past;
  }

  onLangFromHeader(code: Language): void {
    this.landingLang = normalizeThiLang(code);
    this.dir = getDirection(this.landingLang);
    this.fontClass = getFontClass(this.landingLang);
    this.translate.use(this.landingLang);
  }
}
